import styled from "styled-components"


const Header = styled.div`
    width: 100%;
    text-align: left;
    margin: 0 auto;
    background: ${({ theme }) => theme.headerBackground};
	position: sticky;
	top: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width:100%
`;

export default Header;